<template>
	<v-navigation-drawer
		class="sidebar-border media-print modern-sidebar-fixed"
		app
		fixed
		height="100vh"
		hide-overlay
		mini-variant-width="53"
		:mini-variant.sync="mini"
		stateless
		width="250"
		v-model="drawer"
	>
		<v-toolbar flat height="40" class="background-bar hide-and-print">
			<v-list class="pt-0">
				<v-list-tile class="align-image">
					<v-list-tile-action v-if="mini">
						<router-link :to="{ name: nameRoute }">
							<img
								:src="iconClose"
								alt=""
								width="25"
								height="29"
								class="icon-maki-ocult"
							/>
						</router-link>
					</v-list-tile-action>
					<v-list-tile-action v-else>
						<router-link :to="{ name: nameRoute }">
							<img class="imgLogo" :src="iconOpen" :width="widthIcon" height="25">
						</router-link>
					</v-list-tile-action>
				</v-list-tile>
			</v-list>
		</v-toolbar>
		
		<v-toolbar flat height="60" class="btnMenu">
			<v-list>
				<v-list-tile avatar class="bars-align" height="60">
					<v-list-tile-action class="btn-toggle" height="60">
						<v-btn icon @click.native.stop="$emit('click-btn-toggle')" class="icon-open-menu">
							<img
								src="https://maki-acl1.s3.amazonaws.com/iconosNew/icon-menu-logo.png"
								width="24"
								height="24"
								v-if="mini"
								class="img-logo"
							/>
							<img
								src="/static/icon/close.svg"
								height="18"
								v-else
							/>
						</v-btn>
					</v-list-tile-action>
				</v-list-tile>
			</v-list>
		</v-toolbar>
		
		<v-divider></v-divider>
		
		<v-list class="sidebar-bg py-0 modern-menu-list">
			<v-list-group
				v-for="item in items"
				:key="item.id"
				no-action
				class="modern-menu-group"
			>
				<v-list-tile
					v-if="item.resource.data.length === 0"
					slot="activator"
					:to="item.uri"
					@click.native.stop="$emit('click-list')"
					color="white"
					active-class="white--text modern-active"
					class="modern-single-item enhanced-item"
				>
					<v-list-tile-action class="enhanced-icon-action">
						<v-tooltip right>
							<div class="icon-container" slot="activator">
								<img class="icon-sidebar modern-icon" :src="item.pathIcon">
							</div>
							<span>{{ item.name }}</span>
						</v-tooltip>
					</v-list-tile-action>
					<v-list-tile-content>
						<v-list-tile-title class="modern-menu-title enhanced-title">{{ item.name }}</v-list-tile-title>
					</v-list-tile-content>
				</v-list-tile>
				
				<v-list-tile
					v-else
					slot="activator"
					class="padding-items modern-parent-item enhanced-item"
					color="white"
				>
					<v-list-tile-action class="enhanced-icon-action">
						<v-tooltip right>
							<div class="icon-container" slot="activator">
								<img class="icon-sidebar modern-icon" :src="item.pathIcon">
							</div>
							<span>{{ item.name }}</span>
						</v-tooltip>
					</v-list-tile-action>
					<v-list-tile-content class="content-open ml-2 body-2 white--text enhanced-parent-content">
						<v-list-tile-title class="itemName modern-parent-title enhanced-title">{{ item.name }}</v-list-tile-title>
						<v-icon class="enhanced-arrow">keyboard_arrow_down</v-icon>
					</v-list-tile-content>
				</v-list-tile>
				
				<v-list-tile
					v-for="subItem in item.resource.data"
					:key="subItem.uri"
					:to="{ name: subItem.uri }"
					color="white"
					@click.native.stop="$emit('click-list')"
					class="resources-items modern-sub-item enhanced-sub-item"
					active-class="white--text modern-sub-active"
				>
					<v-list-tile-action class="enhanced-sub-action">
						<v-tooltip right>
							<v-icon
								slot="activator"
								color="white"
								class="title-action modern-dot"
							>lens</v-icon>
							<span>{{ subItem.name }}</span>
						</v-tooltip>
					</v-list-tile-action>
					<v-list-tile-content>
						<v-list-tile-title class="modern-sub-title enhanced-sub-title">{{ subItem.name }}</v-list-tile-title>
					</v-list-tile-content>
				</v-list-tile>
			</v-list-group>
		</v-list>
	</v-navigation-drawer>
</template>

<script>
import helper from '@/shared/helper';
import { mapGetters } from 'vuex';

function created() {
	this.widthIcon();
	const iconOpen = process.env.LOGO_SIDEBAR;
	const iconClose = process.env.LOGO_SIDEBAR_CLOSE;
	this.iconOpen = iconOpen || 'https://maki-bucket1.s3.amazonaws.com/7102C744-A748-4EA2-8B4A-7664ED46F9B5.svg';
	this.iconClose = iconClose || 'https://maki-acl1.s3.amazonaws.com/iconosNew/icon-ocult-makipos.png';
	this.loadData();
}

function nameRoute() {
	return this.isMibodega ? 'dashboard-report' : 'main';
}

async function loadData() {
	try {
		const response = await this.$httpAcl.get(`sidebar/${process.env.APP_CODE}`);
		this.items = response.data.data.map((item) => {
			const newItem = Object.assign({}, item);
			if (item.id === 149) {
				newItem.pathIcon = 'https://maki-static.s3.amazonaws.com/3eqm71hx_image/DAVJF_0501662316001/principal-44.png';
			} else if (item.id === 129) {
				newItem.pathIcon = 'https://maki-static.s3.amazonaws.com/3eqm71hx_image/DAVJF_0501662316001/ecommerce97.png';
			}
			if (item.resource.data.length === 0) {
				if (item.uri === this.$route.path) {
					newItem.active = true;
				}
			} else {
				item.resource.data.forEach((src) => {
					if (src.uri === this.$route.path || `/${src.uri}` === this.$route.path) {
						newItem.active = true;
					}
				});
				item.resource.data.sort((a, b) => a.position - b.position);
			}
			return newItem;
		}).sort((a, b) => a.position - b.position);
		helper.setLocalData('sidebar', this.items);
		this.$emit('active-route', this.items);
		localStorage.setItem('sidebarApp', this.items);
	} catch (err) {
		this.$store.showSnackBar({
			color: 'error',
			text: 'Error interno, recargue la página e intente de nuevo',
		});
	}
}

function openMenu() {}

function widthIcon() {
	return this.iconOpen ? '110px' : '65px';
}

function data() {
	return {
		drawer: true,
		items: [],
	};
}

export default {
	name: 'enhanced-sidebar',
	computed: {
		...mapGetters('user', [
			'userAvatarSideBar',
			'userName',
		]),
		nameRoute,
	},
	created,
	data,
	methods: {
		loadData,
		openMenu,
		widthIcon,
	},
	props: {
		mini: {
			type: Boolean,
			default: false,
		},
	},
};
</script>

<style lang="scss" scoped>
// Mantener todos los estilos originales
.list {
	&__tile__action {
		justify-content: flex-end;
	}
}

.content-open {
	align-items: center;
	display: flex;
	flex-direction: row;
	.itemName{
		text-transform: uppercase;
	}
}

aside,
.sidebar-bg {
	background: color(sidebar-bg);
}

.align-image {
	align-content: center;
	height: 40px;
}

.background-bar {
	background-color: #02979b!important;
	justify-content: center;
	margin-top: 1px;

	@media (max-width: 760px) {
		display: none;
	}
}

.navigation-drawer {
	background: map-get($colors, background);
	top: 40px;

	&--mini-variant {
		.list__tile__action {
			justify-content: center;
		}
	}
}

.btn-toggle {
	@media (max-width: 768px) {
		display: none;
	}
}

.title-action {
	font-size: map-get($sizes, small8);
    margin-right: 5px;
}

.resources-items {
	background-color: #03888c;
	cursor: pointer;
}

.imgLogo {
	right: -50px;
	position: relative;
}

// Mejoras modernas sutiles que no rompen el diseño
.modern-sidebar-fixed {
	box-shadow: 2px 0 8px rgba(0, 0, 0, 0.1);
	transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.modern-menu-list {
	scroll-behavior: smooth;
}

.modern-menu-group {
	margin-bottom: 2px;
}

// NUEVAS MEJORAS SOLICITADAS

// Items más grandes
.enhanced-item {
	transition: all 0.2s ease;
	border-radius: 0;
	
	&:hover {
		background-color: rgba(255, 255, 255, 0.05) !important;
		transform: translateX(2px);
	}
}

.enhanced-sub-item {
	transition: all 0.2s ease;
	&:hover {
		background-color: rgba(3, 136, 140, 0.8) !important;
		transform: translateX(4px);
	}
}

// Contenedor de iconos con cuadro y fondo oscuro
.icon-container {
	display: flex;
	align-items: center;
	justify-content: center;
	width: 32px;
	height: 32px;
	background-color: rgba(0, 0, 0, 0.2); // Fondo más oscurito
	border-radius: 8px; // Border radius 5px como solicitaste
	transition: all 0.3s ease;
	
	&:hover {
		background-color: rgba(0, 0, 0, 0.3);
		transform: scale(1.05);
	}
}

.enhanced-icon-action {
	min-width: 48px;
	display: flex;
	align-items: center;
	justify-content: center;
}

.enhanced-sub-action {
	min-width: 40px;
	display: flex;
	align-items: center;
	justify-content: center;
}

// Iconos dentro del contenedor
.modern-icon {
	width: 18px;
	height: 18px;
	filter: brightness(1.2);
	transition: transform 0.2s ease;
}

// Flechas para items principales con submenús
.enhanced-arrow {
	color: white !important;
	font-size: 18px !important;
	transition: transform 0.3s ease;
	margin-left: auto;
}

.enhanced-parent-content {
	display: flex;
	justify-content: space-between;
	align-items: center;
	width: 100%;
}

// Animación de flecha al expandir
.modern-parent-item:hover .enhanced-arrow {
	transform: rotate(180deg);
}

// Títulos con mejor espaciado
.enhanced-title {
	font-weight: 500;
	letter-spacing: 0.25px;
	font-size: 14px;
}

.enhanced-sub-title {
	font-weight: 400;
	letter-spacing: 0.25px;
	font-size: 13px;
}

// Estados activos mejorados
.modern-active {
	background-color: rgba(255, 255, 255, 0.1) !important;
	
	.enhanced-title {
		font-weight: 600;
		color: white !important;
	}
	
	.icon-container {
		background-color: rgba(255, 92, 0, 0.2);
	}
}

.modern-sub-active {
	background-color: rgba(3, 136, 140, 0.9) !important;
	
	.enhanced-sub-title {
		font-weight: 600;
		color: white !important;
	}
	
	.modern-dot {
		color: white !important;
	}
}

// Responsive mejorado
@media (max-width: 768px) {
	.modern-sidebar-fixed {
		.enhanced-item,
		.enhanced-sub-item {
			&:hover {
				transform: none;
			}
		}
	}
}

// Mini variant adjustments
.v-navigation-drawer--mini-variant {
	.enhanced-icon-action {
		min-width: 0;
		margin: 0;
	}
	
	.icon-container {
		width: 28px;
		height: 28px;
	}
	
	.modern-icon {
		width: 16px;
		height: 16px;
	}
}

// Scrollbar personalizado sutil
.modern-sidebar-fixed::-webkit-scrollbar {
	width: 3px;
}

.modern-sidebar-fixed::-webkit-scrollbar-track {
	background: rgba(255, 255, 255, 0.05);
}

.modern-sidebar-fixed::-webkit-scrollbar-thumb {
	background: rgba(255, 255, 255, 0.2);
	border-radius: 2px;
	
	&:hover {
		background: rgba(255, 255, 255, 0.3);
	}
}
</style>


// WEBPACK FOOTER //
// src/components/shared/app-sidebar.vue